var React = require('react');

function KeyboardBackspace (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M21,11H6.83L10.41,7.41L9,6L3,12L9,18L10.41,16.58L6.83,13H21V11Z"}));
}

KeyboardBackspace.defaultProps = {"version":"1.1","width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = KeyboardBackspace;

KeyboardBackspace.default = KeyboardBackspace;
